import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './User.module.css';

function User({ userdata }) {
  const username = userdata.fullname || userdata.username || userdata.email;
  const avatar = userdata.profile_image_url || 'img/avatar-150.png';
  const { t } = useTranslation();

  return (
    <>
      <img src={avatar} className={styles.avatar} alt={t('avatar')} />
      <span>{username}</span>
    </>
  );
}

User.propTypes = {
  userdata: PropTypes.shape({
    fullname: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string.isRequired,
    profile_image_url: PropTypes.string,
  }).isRequired,
};

export default User;
